import { HOLAT_RANGLARI } from "@/shared/charts/palette";

/**
 * Boshqaruv panelining diagramma palitrasi.
 *
 * ⚠️⚠️ **Bu fayl MANBA EMAS — qiymatlar `shared/charts/palette.ts` dan
 * import qilinadi** (spec `2026-09-17-hisobotlar-analitika-design.md`
 * §2.1, 17.09 foydalanuvchi qarori). Ilgari bu yerda «uchlik
 * kengaytirilmaydi» qoidasi turardi; spec §2.1 uni BEKOR qildi — endi
 * butun ilovada 5 holat rangi (+ neytral) bor va ular bitta manbada.
 * Yangi rang kerak bo'lsa, `HOLAT_RANGLARI` ga qarang, bu yerga hex
 * YOZMANG.
 *
 * ⚠️⚠️ **Kanvas rang qoidasini o'zi buzadi.** Kanvas (`Main.dc.html:17`)
 * `--good:#0ca30c` (yashil) va `--crit:#d03b3b` (qizil) ni «Kelgan» va
 * «Kelmagan» ga beradi — deuteranopiyada ΔE 4,1, CVD chegarasi 8.
 * Oddiy ko'rishda ular yaxshi ajraladi, ya'ni nuqsonni ko'z bilan
 * SEZIB BO'LMAYDI. Tema yashili palitraga kirmaydi (`palette.test.ts`).
 *
 * | Ma'no                                         | Kalit       |
 * |-----------------------------------------------|-------------|
 * | Kelgan · sparkline · bo'lim barlari · Hududda | `kelgan`    |
 * | Kelmagan · fake location                      | `kelmagan`  |
 * | Kechikkan                                     | `kechikkan` |
 * | Erta ketgan · Tashqarida · ma'lumotsiz        | `neytral`   |
 *
 * ⚠️ `neytral` — `theme.ts` `colorTextTertiary` bilan teng (test
 * pinlaydi). ⚠️ **`theme.ts` GA TEGILMAYDI** — `theme.test.ts` har
 * tokenini qulflagan va tema butun ilova bo'ylab bo'lishiladi.
 *
 * ⚠️ **Trend yo'nalishi RANG bilan berilmaydi** — faqat strelka +
 * ishora (`↑ 1,4 p.p.` / `↓ 0,6 p.p.`).
 *
 * ⚠️ Qiymatlar LIGHT hex — dashboard komponentlari va testlari inline
 * `style` hex'iga tayanadi. Dark rejimga moslash (`holatVar()`) Blok A
 * primitivlariga o'tishda bajariladi.
 */
export type DashboardRang = "kelgan" | "kelmagan" | "kechikkan" | "neytral";

/**
 * ⚠️ Tip `Record<DashboardRang, string>`, `as const` EMAS. `as const`
 * bilan qiymatlar LITERAL tipga tushib, `expect(rang).toBe(hexSatri)`
 * kabi taqqoslashlar typecheck'da yiqilardi.
 */
export const DASHBOARD_RANGLARI: Record<DashboardRang, string> = {
	kelgan: HOLAT_RANGLARI.kelgan.light,
	kelmagan: HOLAT_RANGLARI.kelmagan.light,
	kechikkan: HOLAT_RANGLARI.kechikkan.light,
	neytral: HOLAT_RANGLARI.neytral.light,
};

/**
 * Bo'limlar kesimidagi maqsad chizig'i (foiz).
 *
 * ⚠️ **Bu domen SOZLAMASI EMAS** — `packages/core/src/settings.ts` da
 * bunday kalit yo'q va uni o'sha yerga ulashga urinmang. Bu KO'RINISH
 * chegarasi, `LIVE_MAP_FRESH_MIN` (`attendance.repository.ts`) bilan
 * bir xil naqsh: diagrammani o'qishga yordam beradigan konstanta,
 * biznes qoidasi emas.
 */
export const MAQSAD_FOIZ = 95;
